import React from 'react';
import Jeep from '../../images/jeep.jpg'
import family from '../../images/familyMan.jpg'
import generic from '../../images/bestPlaces.jpg'
import Carousel from 'react-multi-carousel';
// import '../App.css';
export default function About(){
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 1
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };
    return (
        <>
        <div className='aboutHero'>
            <img alt="family"src={generic}/>  
            <h1>About Jorge</h1>          
        </div>
        <p className='aboutIntro'>"As a Real Estate Agent at the Top of the field, my goals are to have my clients become
        successful in the selling or purchasing of their next investment or property. To help my
        clients in the buying and selling process, I provide the tools to make educated choices with
        their investments, whether that be a vacant lot or a new home. Success is measured in the excitement my clients get when they close on their new
        property. When they succeed, I also do. Success for everyone is in the relationships we build. I reach out to all my clients
        as if they were my neighbors. We'll all grow in our business relationship and make a new friend.
        Let's make the move together."</p>
        <hl></hl>
        <div className="About-sections">
            <div className="About-container">
                <img src={Jeep} className="About-pic"/>
                <div className="About-text-container">
                    <h1>Well Traveled</h1>
                    <p className="About-text">Jorge is far more than just a person behind a desk making calls—he’s a seasoned traveler with firsthand knowledge of the area you’re looking to move to. With extensive experience exploring the state in style, Jorge brings invaluable insights that go beyond what you’ll find in a brochure. Whether you're moving across town or to a new region, his expertise will help guide you in making an informed and confident decision for your next chapter.</p>
                </div>
            </div>
            <div className="About-container">
                <div className="About-text-container">
                    <h1>Family Man</h1>
                    <p className="About-text">Jorge is a dedicated family man who truly understands the challenges and urgency of relocating your loved ones. He knows that moving a family can be a stressful and emotional journey, which is why he’s committed to doing everything he can to help you find the perfect home—one that will bring happiness and peace to your family. With Jorge by your side, you’ll have the reassurance that you’re not just working with a professional, but with someone who genuinely cares about your needs and will guide you every step of the way to make the process as smooth and stress-free as possible. </p>
                </div>
                <img src={family}/>
            </div>
            <h1 style={{'font-size': '60px', 'margin-bottom': '10px'}}>See What People Say About Jorge</h1>
            <Carousel className='reviewCarousel' responsive={responsive} showDots={true} draggable={false} infinite={true}>
                <div className='review'>
                    <h1>Gili</h1>
                    <p>"Jorge made the process simple and easy. Very professional, great personality,
                    honest, patience, great communication regularly through the whole process! His
                    insight to me was extremely valuable, very helpful! I would highly recommend Jorge!"</p>
                </div>
                <div className='review'>
                    <h1>Quinto</h1>
                    <p>Jorge is an extremely knowledgable real estate agent, well versed in all aspects of
                    the sale. Throughout the entire process, Jorge responded quickly to my calls and
                    had answers for any concerns. He kept me updated and helped me make some
                    major decisions. I would highly recommend Jorge Sousa to anyone looking for a
                    competent and dedicated agent.</p>
                </div>
                <div className='review'>
                    <h1>Tonia</h1>
                    <p>Jorge was top notch. He came right and had my house on the market in no time. The house had
                    more showings then I could keep up with day one with multiple offers and by end of day we had a
                    cash offer over asking and fast closing date. Which is what I needed!!! He's super nice and a breeze
                    to work with. Don't hesitate to list with him. I highly recommend it.</p>
                </div>
                <div className='review'>
                    <h1>Paul</h1>
                    <p>The real estate transaction he conducted on my behalf was a bit unique as I live 1,500 miles away. Jorge took the reins and exceeded my expectations at every turn – from cleaning the home to making frequent visits prior to conducting showings. From my experience, this is not the norm, it is the exception.</p>
                </div>
                <div className='review'>
                    <h1>Rebecca</h1>
                    <p>He was amazing from beginning to closing. He helped me through the process when I was ready to
                    back out. He helped calm me down and helped me understand the steps to buying a new home. He
                    answered every message, text and email. He had the answers or he inquired about the answers for me.
                    Helped with the inspections and my lender's needs. At closing he even gave me a gift. Which was
                    thoughtful and amazing.</p>
                </div>
            </Carousel>
        </div>
        </>
    )
}